<template>
  <div class="space-between-y">
    <el-dialog title="所有商品" :visible.sync="dialogProduct">
      <product-all></product-all>
    </el-dialog>

    <sale-order-all ref="tab"></sale-order-all>

  </div>
</template>

<script>
import ProductAll from "@/pages/ProductAll.vue";
import SaleOrderAll from "@/components/saleOrder/SaleOrderAll.vue";
import InputItem from "@/components/base/layout/InputItem.vue";

export default {
  name: 'Order',
  components: {InputItem, SaleOrderAll, ProductAll},
  data() {
    return {
      dialogProduct: false,
    };
  },
};
</script>
